// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeWorkflowV2_1__contentWrap__NlUnQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeWorkflowV2_1/ConsentTypeWorkflowV2_1.css
// module id = 3154
// module chunks = 0